export type WorkspaceDataChangeKind =
  | 'site-created'
  | 'scan-updated'
  | 'manual-issue-created'
  | 'manual-issue-updated';

export interface WorkspaceDataChangedDetail {
  kind: WorkspaceDataChangeKind;
  siteId?: string;
}

const WORKSPACE_DATA_CHANGED_EVENT = 'ablecomply:workspace-data-changed';

export function dispatchWorkspaceDataChanged(detail: WorkspaceDataChangedDetail): void {
  window.dispatchEvent(new CustomEvent<WorkspaceDataChangedDetail>(WORKSPACE_DATA_CHANGED_EVENT, { detail }));
}

export function subscribeToWorkspaceDataChanges(
  listener: (detail: WorkspaceDataChangedDetail) => void,
): () => void {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<WorkspaceDataChangedDetail>;
    if (customEvent.detail) {
      listener(customEvent.detail);
    }
  };

  window.addEventListener(WORKSPACE_DATA_CHANGED_EVENT, handler);
  return () => window.removeEventListener(WORKSPACE_DATA_CHANGED_EVENT, handler);
}
